// src/components/CreateBitbucketModal.tsx

import React from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';

interface CreateBitbucketModalProps {
  show: boolean;
  onHide: () => void;
  newBitbucketRepo: { name: string };
  setNewBitbucketRepo: React.Dispatch<React.SetStateAction<{ name: string }>>;
  handleCreateBitbucketRepo: (e: React.FormEvent) => void;
  creatingRepoLoading: boolean; // <--- new
}

const CreateBitbucketModal: React.FC<CreateBitbucketModalProps> = ({
  show,
  onHide,
  newBitbucketRepo,
  setNewBitbucketRepo,
  handleCreateBitbucketRepo,
  creatingRepoLoading
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Create New Bitbucket Repo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleCreateBitbucketRepo}>
          <Form.Group controlId="bitbucketRepoName">
            <Form.Label>Repo Name</Form.Label>
            <Form.Control
              type="text"
              required
              value={newBitbucketRepo.name}
              onChange={(e) => setNewBitbucketRepo({ ...newBitbucketRepo, name: e.target.value })}
              disabled={creatingRepoLoading} // <--- disable while creating
            />
          </Form.Group>

          {/* Optionally add fields for projectKey, isPrivate, etc. */}

          {creatingRepoLoading ? (
            <Button variant="primary" type="submit" disabled>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              {' '}Creating...
            </Button>
          ) : (
            <Button variant="primary" type="submit">
              Create Repo
            </Button>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateBitbucketModal;
